import React from "react";
import { motion } from "framer-motion";
import { Clock, ClipboardCheck, Workflow, Shield, Network, MessageCircle } from "lucide-react";

const BENEFITS = [
  { icon: Clock, t: "Consultas organizadas y enfocadas", d: "Cada visita está diseñada para aprovechar al máximo tu tiempo y resolver tus dudas." },
  { icon: ClipboardCheck, t: "Seguimiento estructurado del embarazo", d: "Plan claro durante los 9 meses con calendarización de estudios y consultas." },
  { icon: Workflow, t: "Procesos claros y predecibles", d: "Desde la primera consulta hasta el nacimiento de tu bebé, sin pasos ambiguos." },
  { icon: Shield, t: "Calidad y seguridad del paciente", d: "Protocolos basados en evidencia médica y estándares hospitalarios." },
  { icon: Network, t: "Coordinación eficiente", d: "Estudios, tratamientos y seguimiento integrados en un solo flujo de atención." },
  { icon: MessageCircle, t: "Comunicación continua", d: "Canal directo por WhatsApp para resolver dudas entre consultas." },
];

export default function BenefitsSection() {
  return (
    <section
      data-testid="benefits-section"
      className="relative py-20 md:py-28 overflow-hidden"
    >
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-white via-brand-cloud/40 to-white" />
      <div className="absolute -bottom-20 right-10 w-80 h-80 rounded-full bg-brand-bright/10 blur-3xl pointer-events-none" />

      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="flex flex-col items-center text-center mb-14 max-w-3xl mx-auto">
          <p className="text-xs uppercase tracking-[0.28em] text-brand-medical mb-3">Experiencia del paciente</p>
          <h2 className="font-serif text-4xl md:text-5xl text-brand-deep leading-[1.05]">
            Una atención médica <em className="not-italic text-gradient-blue">diseñada para ti</em>.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {BENEFITS.map((b, i) => (
            <motion.article
              key={b.t}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.65, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
              whileHover={{ y: -6 }}
              data-testid={`benefit-${i}`}
              className="group relative rounded-3xl bg-white hairline premium-shadow hover:premium-shadow-hover p-7 transition-shadow duration-500"
            >
              <div className="flex items-center gap-3 mb-5">
                <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-brand-cloud to-brand-silver ring-1 ring-brand-silver/60 flex items-center justify-center">
                  <b.icon className="w-5 h-5 text-brand-medical" strokeWidth={1.4} />
                </div>
                <span className="text-[10px] uppercase tracking-[0.22em] text-brand-medical">0{i + 1}</span>
              </div>
              <h3 className="font-serif text-xl text-brand-deep leading-snug mb-2">{b.t}</h3>
              <p className="text-brand-deep/65 font-light leading-relaxed">{b.d}</p>
              <div className="mt-5 h-px silver-line opacity-0 group-hover:opacity-100 transition-opacity" />
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
